import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import Table, { TableBody, TableHeader } from "../../../../components/Table";
import { TableProps } from "./types";
import {
  BYTES_IN_GB,
  MILLISECOND_IN_DAY,
} from "../../../../utils/common/contants";
import {
  formatNumber,
  getMonthDayYearDate,
  round,
} from "../../../../utils/common";
import Row from "../../../../components/Table/components/Row";
import { getKey, useColumnsConfig } from "../../../../components/Table/utils";

import "./styles.scss";

export const ManageServicesTable: FC<TableProps> = ({ data, summary }) => {
  const { t } = useTranslation();

  const columns = [
    {
      field: "period_starts_at",
      sortable: false,
      headerName: t("periodStart"),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any) => {
        return getMonthDayYearDate(new Date(rowData.period_starts_at));
      },
    },
    {
      field: "period_ends_at",
      sortable: false,
      headerName: t("periodEnd"),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any) => {
        return getMonthDayYearDate(new Date(rowData.period_ends_at));
      },
    },
    {
      field: "days",
      sortable: false,
      headerName: t("days", { days: 0 }),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any): any => {
        const time =
          new Date(rowData.period_ends_at).getTime() -
          new Date(rowData.period_starts_at).getTime();
        return round(time / MILLISECOND_IN_DAY, 2).toFixed(2);
      },
    },
    {
      field: "amount",
      sortable: false,
      headerName: t("bytes"),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any): any => {
        return formatNumber(rowData.amount);
      },
    },
    {
      field: "gb",
      sortable: false,
      headerName: t("GB"),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any): any => {
        return round(rowData.amount / BYTES_IN_GB, 2).toFixed(2);
      },
    },
  ];

  const extraRowColumns = useColumnsConfig([
    {
      field: "period_starts_at",
      sortable: false,
      headerName: t("periodStart"),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any) => {
        return rowData?.period_starts_at
          ? getMonthDayYearDate(new Date(rowData.period_starts_at))
          : "--";
      },
    },
    {
      field: "period_ends_at",
      sortable: false,
      headerName: t("periodEnd"),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any) => {
        return rowData?.period_ends_at
          ? getMonthDayYearDate(new Date(rowData.period_ends_at))
          : "--";
      },
    },
    {
      field: "days",
      sortable: false,
      headerName: t("days", { days: 0 }),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any): any => {
        return round(rowData?.days, 2).toFixed(2);
      },
    },
    {
      field: "bytes",
      sortable: false,
      headerName: t("bytes"),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any): any => {
        return rowData?.bytes ? formatNumber(rowData?.bytes) : 0;
      },
    },
    {
      field: "gb",
      sortable: false,
      headerName: t("GB"),
      cellClass: "ams-manage-services-table__cell",
      valueGetter: ({ rowData }: any): any => {
        return rowData?.bytes / BYTES_IN_GB;
      },
    },
  ]);

  return (
    <Table className="ams-manage-services-table" key="">
      <TableHeader columns={columns} />
      <TableBody columns={columns} data={data}>
        <Row
          className="ams-table__summary"
          key={getKey("tr", data?.length)}
          data={summary as any}
          columns={extraRowColumns}
        />
      </TableBody>
    </Table>
  );
};
